import { useCallback } from 'react';
import Image from 'next/image';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import useT from '@/lib/t';

export default function CopyIcon({ text }: { text: string }) {
  const c = useT('share');
  const handleCopy = useCallback(() => {
    toast.info(c('linkCopied'));
  }, [toast, c]);

  return (
    <CopyToClipboard onCopy={handleCopy} text={text}>
      <div>
        <div
          data-tip={c('copyLink')}
          className={'w-12 h-12 hover:bg-gray100  items-center justify-center sm:hidden md:flex'}
        >
          <Image width={24} height={24} className={'w-6 h-6 '} src={'/icons-share-filled.png'} />
        </div>
        <div
          data-tip={c('copyLink')}
          className={'w-12 h-12 hover:bg-gray100 flex items-center justify-center md:hidden'}
        >
          <IconShareWhite />
        </div>
      </div>
    </CopyToClipboard>
  );
}
const IconShareWhite = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='none' viewBox='0 0 62 62'>
      <g filter='url(#filter0_dddd)'>
        <path
          fill='#fff'
          d='M43 28.08c-.76 0-1.44.3-1.96.77l-7.13-4.15c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7l-7.05 4.11c-.54-.5-1.25-.81-2.04-.81-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z'
        />
      </g>
      <defs>
        <filter
          id='filter0_dddd'
          width='80'
          height='80'
          x='-3'
          y='-16'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx='4' dy='4' />
          <feGaussianBlur stdDeviation='12' />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx='-4' dy='-4' />
          <feGaussianBlur stdDeviation='12' />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx='-4' dy='4' />
          <feGaussianBlur stdDeviation='12' />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset dx='4' dy='-4' />
          <feGaussianBlur stdDeviation='12' />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect4_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};
